import React from "react";
import SearchField from "../SearchField";
import FormSelect from "../FormSelect";
import AppButton from "../Button";
import DateRangePicker from "../DateRangePicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../Styles/components/table-filters.scss";


export default function TableFilters({
  actions = [],
  className = "",
  customActions = null,
  dateRange = null,
  dateFrom = null,
  dateRangePickerProps = {},
  dateTo = null,
  currencyOptions = [],
  currencyValue = "",
  onDateRangeChange,
  onDateChange,
  onApplyFilters,
  onClearFilters,
  onCurrencyChange,
  onSearchChange,
  onStatusChange,
  onTypeChange,
  searchPlaceholder = "Search",
  searchValue = "",
  selects = [],
  showCurrencyFilter = false,
  showDateRange = false,
  showDatePicker,
  showSearch,
  showStatusFilter = false,
  showTypeFilter = false,
  statusOptions = [],
  statusValue = "",
  typeOptions = [],
  typeValue = "",
  hasSearchButton = false,
  apiName = null,
  payload = {},
}) {

  const shouldShowSearch =
    showSearch !== undefined ? Boolean(showSearch) : Boolean(onSearchChange);
  const shouldShowDateRange = Boolean(
    showDatePicker !== undefined ? showDatePicker : showDateRange,
  );
  const normalizedDateRange = dateRange || (dateFrom || dateTo ? [dateFrom, dateTo] : null);
  const normalizedSelects = [
    ...(showStatusFilter
      ? [
          {
            key: "status",
            options: statusOptions,
            value: statusValue,
            onChange: onStatusChange,
          },
        ]
      : []),
    ...(showTypeFilter
      ? [
          {
            key: "type",
            options: typeOptions,
            value: typeValue,
            onChange: onTypeChange,
          },
        ]
      : []),
    ...(showCurrencyFilter
      ? [
          {
            key: "currency",
            options: currencyOptions,
            value: currencyValue,
            onChange: onCurrencyChange,
          },
        ]
      : []),
    ...selects,
  ];
  const normalizedActions = [
    ...actions,
    ...(onClearFilters
      ? [
          {
            key: "clear-filters",
            label: "Clear",
            variant: "secondary",
            onClick: onClearFilters,
          },
        ]
      : []),
    ...(onApplyFilters
      ? [
          {
            key: "apply-filters",
            label: "Apply",
            variant: "primary",
            onClick: onApplyFilters,
          },
        ]
      : []),
  ];

  const handleSearch = async () => {
    if (typeof apiName !== "function") return;
    await apiName(payload);
  };
  const hasActions = normalizedActions.length > 0 || Boolean(customActions);
  const hasSearch = shouldShowSearch && Boolean(onSearchChange);
  const hasSelects = normalizedSelects.length > 0;
  const hasRightControls = shouldShowDateRange || hasSelects || hasActions;
  const isDateOnlyControls =
    shouldShowDateRange && !hasSearch && !hasSelects && !hasActions;

  return (
    <div
      className={[
        "table-filters",
        isDateOnlyControls ? "table-filters--date-only" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {hasSearch ? (
        <div className="table-filters__left">
          <SearchField
            className="table-filters__search"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value, event)}
          />
          {hasSearchButton ? (
            <AppButton
              className="table-filters__search-button"
              type="button"
              variant="primary"
              onClick={handleSearch}
            >
              Search
            </AppButton>
          ) : null}
        </div>
      ) : null}

      {hasRightControls ? (
        <div className="table-filters__controls">
          {shouldShowDateRange ? (
            <DateRangePicker
              value={normalizedDateRange}
              onChange={(range) => {
                onDateRangeChange?.(range);
                onDateChange?.(range);
              }}
              {...dateRangePickerProps}
            />
          ) : null}

          {normalizedSelects.map((select) => (
            <FormSelect
              key={select.key || select.label || select.name}
              className={["table-filters__select", select.className]
                .filter(Boolean)
                .join(" ")}
              disabled={select.disabled}
              label={select.label}
              onChange={(event) => select.onChange?.(event.target.value, event)}
              options={select.options || []}
              value={select.value}
            />
          ))}

          {hasActions ? (
            <div className="table-filters__actions">
              {customActions}
              {normalizedActions.map((action) =>
                React.isValidElement(action) ? (
                  action
                ) : (
                  <AppButton
                    key={action.key || action.label}
                    className={action.className}
                    disabled={action.disabled}
                    loading={action.loading}
                    onClick={action.onClick}
                    type={action.type || "button"}
                    variant={action.variant || "primary"}
                  >
                    {action.icon ? <FontAwesomeIcon icon={action.icon} /> : null}{" "}
                    {action.label}
                  </AppButton>
                ),
              )}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export const TableFilter = TableFilters;
